module.exports = __webpack_public_path__ + "static/media/Group 10947.945cc01e.svg";